// ============================================
// PREGNANCY TOGGLE + ADD-ON CAROUSEL
// Prestige v11.1.0 Compatible
// Cart add handled by Prestige's native ProductForm
// ============================================

document.addEventListener('DOMContentLoaded', function() {
  
  const toggle = document.getElementById('pregnancy-toggle-input');
  const defaultAddons = document.getElementById('default-addons-block');
  const pregnancyAddons = document.getElementById('pregnancy-addons-block');
  
  // ==========================================
  // CAROUSEL FUNCTIONALITY
  // ==========================================
  
  function initCarousel(wrapper) {
    if (!wrapper) return;
    
    const track = wrapper.querySelector('.addons-track');
    const prevBtn = wrapper.querySelector('.addons-arrow--prev');
    const nextBtn = wrapper.querySelector('.addons-arrow--next');
    
    if (!track || !prevBtn || !nextBtn) return;
    
    const cards = track.querySelectorAll('.addon-card');
    if (cards.length === 0) return;
    
    let currentIndex = 0;
    const visibleCount = parseInt(wrapper.dataset.visible) || 2;
    const maxIndex = Math.max(0, cards.length - visibleCount);
    
    function updateCarousel() {
      if (cards.length === 0) return;
      
      const cardWidth = cards[0].offsetWidth;
      const gap = 16;
      const offset = currentIndex * (cardWidth + gap);
      track.style.transform = `translateX(-${offset}px)`;
      
      prevBtn.disabled = currentIndex === 0;
      nextBtn.disabled = currentIndex >= maxIndex;
    }
    
    prevBtn.addEventListener('click', function() {
      if (currentIndex > 0) {
        currentIndex--;
        updateCarousel();
      }
    });
    
    nextBtn.addEventListener('click', function() {
      if (currentIndex < maxIndex) {
        currentIndex++;
        updateCarousel();
      }
    });
    
    // Handle resize
    let resizeTimer;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(updateCarousel, 150);
    });
    
    // Initial update after a short delay to ensure layout is ready
    setTimeout(updateCarousel, 100);
  }
  
  // Init all carousels on page load
  document.querySelectorAll('.addons-carousel-wrapper').forEach(initCarousel);
  
  // ==========================================
  // TOGGLE SWAP FUNCTIONALITY
  // ==========================================
  
  if (!toggle || !defaultAddons) {
    console.log('ℹ️ Pregnancy toggle: Not present on this page');
    return;
  }
  
  function swapCollections() {
    if (toggle.checked) {
      // Pregnancy Mode ON
      defaultAddons.style.display = 'none';
      
      if (pregnancyAddons) {
        pregnancyAddons.style.display = 'block';
        pregnancyAddons.style.opacity = '0';
        pregnancyAddons.style.transform = 'translateY(10px)';
        
        requestAnimationFrame(function() {
          pregnancyAddons.style.transition = 'opacity 0.35s ease, transform 0.35s ease';
          pregnancyAddons.style.opacity = '1';
          pregnancyAddons.style.transform = 'translateY(0)';
        });
        
        // Re-init pregnancy carousel after it becomes visible
        setTimeout(function() {
          const pregWrapper = pregnancyAddons.querySelector('.addons-carousel-wrapper');
          if (pregWrapper) initCarousel(pregWrapper);
        }, 50);
      }
      
    } else {
      // Default Mode ON
      if (pregnancyAddons) {
        pregnancyAddons.style.display = 'none';
      }
      
      defaultAddons.style.display = 'block';
      defaultAddons.style.opacity = '0';
      defaultAddons.style.transform = 'translateY(10px)';
      
      requestAnimationFrame(function() {
        defaultAddons.style.transition = 'opacity 0.35s ease, transform 0.35s ease';
        defaultAddons.style.opacity = '1';
        defaultAddons.style.transform = 'translateY(0)';
      });
      
      // Re-init default carousel
      setTimeout(function() {
        const defWrapper = defaultAddons.querySelector('.addons-carousel-wrapper');
        if (defWrapper) initCarousel(defWrapper);
      }, 50);
    }
  }
  
  toggle.addEventListener('change', swapCollections);
  
  // Initialize state
  swapCollections();
  
  // ==========================================
  // ADD-TO-CART & DRAWER HANDLER FOR ADD-ONS
  // ==========================================
  
  document.addEventListener('submit', function(event) {
    const form = event.target;
    if (!form.classList.contains('addon-product-form__form')) return;
    
    event.preventDefault();
    event.stopImmediatePropagation();
    
    const button = form.querySelector('[type="submit"]');
    let originalText = 'Add to Hamper';
    if (button) {
      originalText = button.innerHTML;
      button.setAttribute('disabled', 'disabled');
      button.setAttribute('aria-busy', 'true');
      button.innerHTML = 'Adding...';
    }
    
    const formData = new FormData(form);
    const cartDrawer = document.querySelector('cart-drawer');
    let sectionsToBundle = [];

    /* The drawer answers this with its own section id, which keeps working after it has been moved to <body> on a
       previous open — `closest('.shopify-section')` returns null once that has happened, and the drawer markup would
       then have to be fetched in a second request. */
    document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {
      bubbles: true,
      detail: { sections: sectionsToBundle }
    }));

    if (!sectionsToBundle.length && cartDrawer) {
      const sectionWrapper = cartDrawer.closest('.shopify-section');

      if (sectionWrapper) {
        sectionsToBundle.push(sectionWrapper.id.replace('shopify-section-', ''));
      }
    }

    if (sectionsToBundle.length) {
      formData.set('sections', sectionsToBundle.join(','));
      formData.set('sections_url', `${Shopify.routes.root}variants/${formData.get('id')}`);
    }

    fetch(`${Shopify.routes.root}cart/add.js`, {
      method: 'POST',
      body: formData,
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
    .then(response => response.json())
    .then(responseJson => {
      if (button) {
        button.removeAttribute('disabled');
        button.removeAttribute('aria-busy');
        button.innerHTML = originalText;
      }
      
      if (responseJson.id || responseJson.items) {
        const addedItems = responseJson.items || [responseJson];
        const currentItemCount = parseInt(document.querySelector('cart-count')?.innerText || '0', 10) || 0;
        const cartContent = {
          item_count: currentItemCount + addedItems.reduce((count, item) => count + (item?.quantity || 1), 0),
          sections: responseJson.sections || {}
        };
        
        document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
          bubbles: true,
          detail: {
            baseEvent: 'variant:add',
            forceCartDrawer: true,
            cart: cartContent
          }
        }));
      } else {
        alert(responseJson.description || 'Could not add product to hamper.');
      }
    })
    .catch(error => {
      console.error('Error adding addon to cart:', error);
      if (button) {
        button.removeAttribute('disabled');
        button.removeAttribute('aria-busy');
        button.innerHTML = originalText;
      }
    });
  }, true); // Capture phase to run before theme.js ProductForm handler

  console.log('✅ Pregnancy toggle, carousel & AJAX cart initialized');
});
